import { AccountDto } from './AccountDto';
import { GroupDto } from './GroupDto';

export class AccountPageData {
  accounts: Array<AccountDto>;
  groups: Array<GroupDto>;
}
